<template>
  <div class="page-cover flex-row justify-center" :class="aiTheme">
    <div v-if="props.type === 'word'" class="page-cover_word flex-column flex-wrap cursor-pointer">
      <h3>
        <span>{{ props.sentence }}</span>
        <span>
          <i
            id="ai-sentence-audio"
            class="iconfont"
            :class="bofangIcon"
            style="color: var(--text-import-color); margin-left: 2vw; vertical-align: middle"
            @click="audioPlay"
          ></i>
        </span>
      </h3>
      <p class="mb-5">{{ props.gptStr }}</p>
      <p v-if="props.descContent" class="mb-5" style="margin-top: 0">
        <span>关键词描述：</span>
        <span v-html="props.descContent"></span>
      </p>
      <!--      <ion-button-->
      <!--        class="ai-vocabulary"-->
      <!--        fill="outline"-->
      <!--        shape="round"-->
      <!--        @click="routerToAiVocabulary(props.sentence)"-->
      <!--        >AI词典-->
      <!--      </ion-button>-->
      <ion-button class="page-cover_word-button" shape="round" @click="putIntoGlossary"
        >加入生词本
      </ion-button>
    </div>
    <div
      v-if="['sentence'].includes(props.type)"
      class="page-cover_word flex-column flex-wrap cursor-pointer"
    >
      <p>{{ props.gptStr }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
/* disabled-eslint */
import { IonButton, popoverController } from "@ionic/vue"
import http from "@/js/http"
import store from "@/js/store"
import { defineProps, onBeforeUnmount, onMounted, ref } from "vue"
import { openMsgToast } from "@/views/AIGenerate/openModal"
import { useStorage } from "@vueuse/core/index"
import getOssPlayInstance from "@/js/ossPlay"

const props = defineProps(["sentence", "type", "gptStr", "descContent", "fromPrepareOrigin"])
const audioPlayer = ref()
const mediaType = ref()
const aiTheme = useStorage("ai-theme", "brown", localStorage)
const bofangIcon = ref("icon-bofang3")
const timer = ref(0)

// 打开AI词典
async function routerToAiVocabulary(word: string) {
  audioStop()
  await popoverController.dismiss({ status: "关闭AI词典", word: word })
}

async function putIntoGlossary() {
  const appointment = store.getAppointment()
  const params = {
    aptmId: appointment.aptmId,
    courseId: appointment.courseId,
    word: props.sentence.trim(),
    courseType: appointment.courseType,
  }

  if (props.fromPrepareOrigin) {
    popoverController.dismiss({ status: "关闭popover" }).catch((e) => console.log(e))
    await openMsgToast("添加成功。")
    return
  }

  http.post("/readingVocabulary/addReadingWordToPersonal", params).then(async (res) => {
    if (res.data.success) {
      popoverController.dismiss({ status: "关闭popover" }).catch((e) => console.log(e))
      await openMsgToast(res.data.messageExtra)
    } else {
      await openMsgToast("加入生词本失败")
    }
  })
}

function audioStop() {
  // if (mediaType.value === "MEDIA_SOURCE") {
  //   if (audioPlayer.value?.pause) {
  //     audioPlayer.value.pause();
  //   }
  // } else if (mediaType.value === "AUDIO_CONTEXT") {
  //   if (audioPlayer.value) {
  //     audioPlayer.value.close();
  //   }
  // }
  // bofangIcon.value = "icon-bofang3";
  // clearInterval(timer.value);
  if (audioPlayer.value) {
    audioPlayer.value.pause()
  }
}

function audioPlay() {
  audioPlayer.value = getOssPlayInstance().init({ msg: props.sentence })
  audioPlayer.value.play()
  // audioPlayStream(props.sentence, (callbackData: any, type: string) => {
  //   mediaType.value = type;
  //   let num = 0;
  //   if (mediaType.value === "MEDIA_SOURCE") {
  //     audioPlayer.value = new Audio(callbackData);
  //     audioPlayer.value.oncanplay = function () {
  //       audioPlayer.value.play();
  //     };
  //     audioPlayer.value.onended = function () {
  //       console.log("ended");
  //       bofangIcon.value = "icon-bofang3";
  //       clearInterval(timer.value);
  //     };
  //     audioPlayer.value.oncanplaythrough = () => {
  //       console.log("loading");
  //       clearInterval(timer.value);
  //       timer.value = window.setInterval(() => {
  //         num = ++num % 3;
  //         bofangIcon.value = `icon-bofang${num + 1}`;
  //       }, 300);
  //     };
  //   } else if (mediaType.value === "AUDIO_CONTEXT") {
  //     audioPlayer.value = callbackData;
  //   }
  // });
}

onBeforeUnmount(() => {
  audioStop()
})
onMounted(() => {
  // 初始化 Audio 播放器
  /* eslint-disable */
  // audioPlayer.value = new AudioPlayer("/assets/js");
})
</script>

<style>
ion-popover::part(content) {
  --width: none !important;
  max-width: 100vw;
}
</style>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/theme/ai-theme.less";

.page-cover {
  padding: 1rem 1.5rem;
  position: relative;

  &_audio {
    width: 5vw;
    cursor: pointer;
    vertical-align: middle;
    margin-left: 2vw;
  }

  &_word {
    h3 {
      font-size: 4vw;
      font-weight: 700;
      margin-bottom: 0;
    }

    p {
      color: #868f9e;
      font-weight: 400;
    }

    &-button {
      &::part(native) {
        --background: var(--text-import-color);
        font-size: 0.8rem;
        --box-shadow: none;
      }
    }

    .ai-vocabulary {
      &::part(native) {
        --background: transparent;
        --border-color: var(--text-import-color);
        color: var(--text-import-color);
      }
    }

    #ai-sentence-audio {
      font-weight: 400;
    }
  }
}
</style>
